export default "__VITE_ASSET__a38fa176__"